import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { Component } from 'react';

class RestrainPartnerRow extends Component {
    render() {
        return (
            <TableContainer component={Paper}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Partner</TableCell>
                            <TableCell>Munkavállaló</TableCell>
                            <TableCell>Megjegyzés</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key="new">
                            <TableCell>{this.props.row.name}</TableCell>
                            <TableCell>{this.props.row.employeeName}</TableCell>
                            <TableCell>{this.props.row.comment}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }
}
export default RestrainPartnerRow;